<template>
  <div class="w-full p-4">
    <!-- The band stays on screen, as on My Expenses. -mt-4 cancels the
         page's own p-4: without it the band rests 16px below where it pins
         and the whole page slides that far before it catches. -->
    <div class="sticky top-14 z-30 bg-gray-200 -mx-4 -mt-4 px-4 pt-3 pb-4">
      <div class="flex flex-row justify-between items-center pb-2 border-b border-b-gray-400">
        <h2 class="text-lg font-semibold">Back Office</h2>
      </div>
    </div>

    <p class="text-sm text-gray-500 mb-6">
      Phase 0 scaffold. This page exists to prove the permission chain and the
      API wiring end to end; the real surfaces land in later slices.
    </p>

    <div class="border border-gray-300 rounded-md bg-white p-4 max-w-2xl">
      <h3 class="font-semibold text-dark-primary mb-3">Department taxonomy</h3>

      <p v-if="loading" class="text-gray-500">Loading…</p>

      <p v-else-if="error" class="text-red-600">
        Could not load departments: {{ error }}
      </p>

      <ul v-else-if="departments.length" class="space-y-2">
        <li v-for="department in departments" :key="department.id">
          <span class="font-medium">{{ department.name }}</span>
          <span v-if="department.sub_departments.length" class="text-gray-500">
            — {{ department.sub_departments.map(s => s.name).join(', ') }}
          </span>
          <span v-else class="text-gray-400">— no sub-departments</span>
        </li>
      </ul>

      <p v-else class="text-gray-500">No departments found.</p>
    </div>

    <div class="border border-gray-300 rounded-md bg-white p-4 max-w-2xl mt-4">
      <h3 class="font-semibold text-dark-primary mb-1">Work items</h3>
      <p class="text-gray-500">
        {{ workItemCount === null ? 'Loading…' : `${workItemCount} in the backlog` }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useStore } from 'vuex'

import { getDepartments, getWorkItems } from '@/services/BackOffice'

const store = useStore()

const departments = ref([])
const workItemCount = ref(null)
const loading = ref(true)
const error = ref('')

onMounted(async () => {
  const token = store.getters['auth/showToken']
  try {
    departments.value = await getDepartments(token)
    const workItems = await getWorkItems(token)
    // The list endpoint is paginated; fall back to array length if not.
    workItemCount.value = workItems.count ?? workItems.length ?? 0
  } catch (e) {
    error.value = e?.response?.status
      ? `${e.response.status} ${e.response.statusText || ''}`.trim()
      : String(e)
  } finally {
    loading.value = false
  }
})
</script>
